<template>
    <div>
        <Row :gutter="16">

            <Layout>
                <Content style="min-width:500px;margin:0 8px">
                    <Card>
                        <p slot="title">{{t.routerName}}</p>
                        <Row>
                            <Col>
                                <Form :model="formItem" :label-width="90" label-position="right"
                                      ref="form">
                                    <FormItem :label="t.user.deptName" prop="deptName">
                                        <Input v-model.trim="formItem.deptName" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.name" prop="name">
                                        <Input v-model.trim="formItem.name" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.email" prop="email">
                                        <Input v-model.trim="formItem.email" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.mobile" prop="mobile">
                                        <Input v-model.trim="formItem.mobile" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.type" prop="type">
                                        <Input v-model.trim="formItem.type" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.sex" prop="sex">
                                        <Input v-model.trim="formItem.sex" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.status" prop="status">
                                        <Input v-model.trim="formItem.status" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.loginIp" prop="loginIp">
                                        <Input v-model.trim="formItem.loginIp" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.loginTime" prop="loginTime">
                                        <Input v-model.trim="formItem.loginTime" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.createBy" prop="createBy">
                                        <Input v-model.trim="formItem.createBy" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.createTime" prop="createTime">
                                        <Input v-model.trim="formItem.createTime" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.updateBy" prop="updateBy">
                                        <Input v-model.trim="formItem.updateBy" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.updateTime" prop="updateTime">
                                        <Input v-model.trim="formItem.updateTime" readonly></Input>
                                    </FormItem>
                                    <FormItem :label="t.user.remark" prop="remark">
                                        <Input v-model.trim="formItem.remark" type="textarea"
                                               :autosize="{minRows: 3,maxRows: 15}" readonly>
                                        </Input>
                                    </FormItem>
                                </Form>
                            </Col>
                        </Row>
                    </Card>
                </Content>
                <Sider hide-trigger width="400" style="background:transparent;margin:0 8px">
                    <Form :model="formItem" ref="form1">
                        <Row>
                            <Card>
                                <img :src="formItem.avatar" class="upload_img"/>
                                <Input type="text" v-model.trim="formItem.loginName" @focus="readonlyStyle" readonly>
                                    <Icon type="ios-person-outline" slot="prepend"></Icon>
                                </Input>
                            </Card>
                        </Row>
                        <Row class="margin-top-10">
                            <Card style="font-size: 12px;">
                                <div slot="title">
                                    <Icon type="logo-buffer"/>
                                    {{t.role.roleDistribute}}
                                </div>
                                <Row class="margin-bottom-10" type="flex" align="middle">
                                    <Col span="4" offset="2">{{t.user.postName}}</Col>
                                    <Col span="18">
                                        <span v-for="item in postList" :value="item.id" :key="item.id">
                                            <Tag type="border">{{ item.name }}</Tag>
                                        </span>
                                    </Col>
                                </Row>
                                <Row class="margin-bottom-10" type="flex" align="middle">
                                    <Col span="4" offset="2">{{t.user.roleName}}</Col>
                                    <Col span="18">
                                        <span v-for="item in roleList" :value="item.id" :key="item.id">
                                            <Tag type="border">{{ item.name }}</Tag>
                                        </span>
                                    </Col>
                                </Row>
                            </Card>
                        </Row>
                    </Form>
                </Sider>
            </Layout>
        </Row>
    </div>
</template>
<script>
import BaseUrl from '_conf/url';
import { edit, getUserInfo } from '@/api/user';
import { getList } from '@/api/dept';
import { getPostList } from '@/api/post';
import { getRoleList } from '@/api/role';

export default {
    name: 'organization_user_detail',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            baseURL: BaseUrl.dataUrl,
            formItem: {
                avatar: '',
                deptId: '',
                loginName: '',
                password: '',
                passwordAgain: '',
                name: '',
                email: '',
                mobile: '',
                sex: '0',
                status: '1',
                type: '0',
                remark: '',
                postIdList: [],
                roleIdList: [],
            },
            correlateObject: {
                status: '1',
                size: '99999',
            },
            deptList: [],
            postList: [],
            roleList: [],
            visible: false,
            uploadList: [],
            show: false,
        };
    },
    methods: {
        readonlyStyle(e) {
            e.trigger('blur');
        },
        async init() {
            const userInfo = await getUserInfo(this.$route.params.id);
            if (userInfo.user != null) {
                this.formItem = userInfo.user;

                if (this.formItem.sex === '1') {
                    this.formItem.sex = this.t.user.female;
                } else {
                    this.formItem.sex = this.t.user.male;
                }

                if (this.formItem.type === '2') {
                    this.formItem.type = this.t.user.systemUser;
                } else if (this.formItem.type === '1') {
                    this.formItem.type = this.t.user.members;
                } else {
                    this.formItem.type = this.t.user.normalUser;
                }

                if (this.formItem.status === '1') {
                    this.formItem.status = this.t.user.open;
                } else {
                    this.formItem.status = this.t.user.close;
                }
            }

            //得到所有岗位
            const posts = await getPostList(this.correlateObject);
            if (posts != null) {
                this.postList = posts.page.records.filter(item => this.formItem.postIdList.includes(item.id));
            }
            //得到所有角色
            const roles = await getRoleList(this.correlateObject);
            if (roles != null) {
                this.roleList = roles.page.records.filter(item => this.formItem.roleIdList.includes(item.id));
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" scoped>
.user-avatar {
    display: inline-block;
    text-align: center;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    line-height: 0px;
    margin-right: 4px;
    cursor: pointer;
    img {
        width: 60px;
        height: 60px;
    }
    &:hover,
    &:focus {
        background-color: rgba(107, 107, 107, 0.178);
    }
}

.ivu-switch {
    border-color: #ed4014;
    background-color: #ed4014;
}

.ivu-switch-checked {
    border-color: #19be6b;
    background-color: #19be6b;
}

.upload_img {
    width: 100%;
}
</style>
